<template>
    <div class="key-value-list-container">
        <div class="key-value-list">
            <div class="key-value-list__header">
                <slot name="header" />

                <img
                    :src="`/api/image-proxy?url=${config.media_logo.filename}/m/500x0/filters:format(webp)`"
                    :alt="`Logo of ${config.brand_name}`"
                    class="key-value-list__logo"
                >
            </div>

            <div class="key-value-list__items">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup>
const { data: config } = await useConfig()
</script>

<style lang="scss">
.key-value-list {
    display: flex;
    flex-direction: column;
    gap: 4cqw;
    background: var(--secondary);
    padding: 4cqw;
    border-radius: 1cqw;

    &-container {
        container: key-value-list / inline-size;
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 4.25cqw;
        line-height: 1.2;
        font-weight: 600;
    }

    &__logo {
        max-height: 6.5cqw;
        max-width: 25cqw;
    }

    &__items {
        display: flex;
        flex-direction: column;
        gap: 2cqw;
    }
}
</style>
